import { Box, Select, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import MeasureResultField from "./MeasureResultField";

export default function SurveyWheelContent() {
  const { t } = useTranslation();

  const darkTheme = defaultStore((state) => state.darkTheme);
  const showSmallToolContent = sidebarStore(
    (state) => state.showSmallToolContent
  );
  const surveyWheelActiveAttributes = sidebarStore(
    (state) => state.surveyWheelActiveAttributes
  );
  const changeSurveyWheelActiveAttributes = sidebarStore(
    (state) => state.changeSurveyWheelActiveAttributes
  );
  const surveyWheelToolValues = sidebarStore(
    (state) => state.surveyWheelToolValues
  );

  const resultFields = [
    {
      id: "surveyWheel_distance",
      label: t("measurement.wheel_distance"),
      value: surveyWheelToolValues || 0,
    },
  ];

  return (
    <>
      <Box sx={{ display: "grid", gap: 0.5 }}>
        {resultFields
          .filter((item: any) => {
            if (showSmallToolContent) {
              return surveyWheelActiveAttributes.includes(item.id);
            } else {
              return item;
            }
          })
          .map((item: any) => (
            <MeasureResultField
              key={item.id}
              id={item.id}
              title={item.label}
              value={item.value + " m"}
              loggingString={item.id}
              activeAttributes={surveyWheelActiveAttributes}
              changeActiveAttributes={changeSurveyWheelActiveAttributes}
              showPin={resultFields.length > 1}
            />
          ))}
      </Box>
    </>
  );
}
